module.exports = "https://assets.sidelineswap.com/web/_next/static/images/missing-avatar-f1dd55ccfbf1ea7b65991ee183ac97b4.png";